import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    data: PropTypes.object.isRequired
};

function PlanInfo(props) {
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

    const convertPhone = phone => {
        return phone.replace(phoneRegex, '$1-$2-$3');
    };

    let {
        planSponsor,
        planSponsorPhone,
        displayFin,
        agentFirstName,
        agentLastName,
        agentPhone
    } = props.data;

    return (

        <li className="asc-card-list-group-item">
            <div className="asc-card-content">
                <span className="asc-card-subtitle">Employer Contact</span>
                <div className="asc-card-value asc-card-actions profile-card-actions">
                    {planSponsor}<br />
                    {convertPhone(planSponsorPhone)}
                </div>
            </div>
            {displayFin && (
                <div className="asc-card-content">
                    <span className="asc-card-subtitle">Financial Advisor</span>
                    <div className="asc-card-value asc-card-actions profile-card-actions">
                        {agentFirstName} {agentLastName}<br />
                        {convertPhone(agentPhone)}
                    </div>
                </div>
            )}      
        </li>

    );
}

PlanInfo.propTypes = propTypes;
export default PlanInfo;
